import {toStringKey} from "classes/helpers";

// RENAME: api -> rest / fetch/ queryHelpers?

import URLSearchParams from '@ungap/url-search-params'

export const SAMPLE_PRODUCT_TYPE_ID = 5;

export class OptionValue {
    /**
     * @param {number} id
     * @param {string} caption
     */
    constructor(id, caption) {
        this.id = id;
        this.caption = caption;
    }

    /**
     *
     * @param {String} parent
     */
    setParent(parent) {
        this.parent = parent
    }

    toString() {
        let returnValue = this.id + ':' + this.caption
        if (this.parent) {
            returnValue = this.parent + "/" + returnValue
        }
        return returnValue
    }
}

/**
 *
 */
export class Option {
    /**
     * @param {number} id
     * @param {string} caption
     * @param {OptionValue[]} values
     */
    constructor(id, caption, values, defaultValueId) {
        this.id = id;
        this.caption = caption;
        this.values = values;
        // having a parent is not good vor serialization
        this.values.forEach(v => v.setParent(this.toString()))
        this.defaultValueId = defaultValueId;
    }

    toString() {
        return this.id + ':' + this.caption + 'web'
    }
}

export class OptionGroup {
    /**
     * @param {number} id
     * @param {string} caption
     * @param {Option[]} options
     */
    constructor(id, caption, options) {
        this.id = id;
        this.caption = caption;
        this.options = options;
    }
}

/**
 * @param exclusions {[String,String][]}
 * @param options {Option[]}
 */
export function writExclusionsToOptions(lookupMap, options) {
    for (const option of options) {
        for (const value of option.values) {
            const key =  toStringKey( option.id, value.id );
            const exclusions = lookupMap.get(key);
            if( exclusions ) {
                value.exclusions = exclusions;
            }
        }
    }
}

export function createExclusionMap(exclusions) {
    const lookupMap = new Map();

    for (const [ov1, ov2] of exclusions) {
        if (!lookupMap.has(ov1)) {
            lookupMap.set(ov1, []);
        }
        if (!lookupMap.has(ov2)) {
            lookupMap.set(ov2, []);
        }
        lookupMap.get(ov1).push(ov2);
        lookupMap.get(ov2).push(ov1);
    }
    return lookupMap;
}
export function createUniExclusionMap(uniExclusions, lookupMap) {

    for (const key of Object.keys(uniExclusions)) {
        for( const exclusion of uniExclusions[key] ) {
            if (!lookupMap.has(exclusion)) {
                lookupMap.set(exclusion, []);
            }
            lookupMap.get(exclusion).push(key);

            if (!lookupMap.has(key)) {
                lookupMap.set(key, []);
            }
            lookupMap.get(key).push(exclusion);
        }
    }
    return lookupMap;
}

export class ShopItemRESTHelper {

    constructor(shopItemId) {
        this.shopItemId = shopItemId
    }

    isOfProduct(key) {
        let requestedItemId = this.shopItemId;
        let url = webroot + "myinterfaces/" + languagepath + "/shop/session/basket/items/" + requestedItemId;
        return new Promise(function (resolve, reject) {
            doGet(url).then(response => {
                if (response.ok) { // shopItem exists
                     if ( response.basket.items.some(item => item.shopItemId === requestedItemId && key.endsWith(item.key))) {
                        resolve()
                    }
                }
                reject()
            })
        })
    }

    updateItem(params, quantity = 1) {
        const url = webroot + `myinterfaces/${languagepath}/shop/session/basket/items/${this.shopItemId}/${quantity}`;

        const searchParams = new URLSearchParams( params )
        return doPost(url, searchParams, "application/x-www-form-urlencoded").then(response => {
            $('body').trigger('basketChanged', response);
        }).catch(xhr => console.log('The request failed!'))
    }

    updateAddresses( data, quantity = 1 ) {
        const url = `${webroot}myinterfaces/${languagepath}/shop/session/basket/items/${this.shopItemId}/${quantity}`;
        // return doPut("/api/prj/splittedshipping/"+this.shopItemId+".de.json", data )
        const formdata = new URLSearchParams()
        for(  const [key,val] of Object.entries( data) ) {
            let value
            if( val instanceof Blob || typeof val == 'string')
                value = val
            else
                value = JSON.stringify(val)
            formdata.append( key, value)
        }
        return fetch( url, { method: 'POST', body: formdata })
            .then( response => response.json() )
            .then( response => $('body').trigger('basketChanged', response) );
    }

}


export class ProduktRESTHelper {
    /**
     * @param {string} key
     */
    constructor(key) {
        this.key = key;
    }

    get(url, data) {

        const urlParams = new URLSearchParams({'productKey': this.key} )

        function build(obj) {
            for (const prop of Object.keys(obj)) {
                // check if prop is not inherited
                if (Array.isArray(obj[prop])) {
                    for (const val of obj[prop])
                        urlParams.append(prop+'[]', val);
                } else if (typeof obj[prop] === 'object') {
                    // recursive
                    urlParams.append(prop, JSON.stringify(obj[prop]))
                } else {
                    urlParams.append(prop,obj[prop]);
                }
            }
        }

        build(data);
        let uri = `${webroot}${url}?` +urlParams.toString();
        return doGet(uri);
    }

    post(url, data) {

        data['productKey'] = this.key;
        const searchParams = new URLSearchParams( data )
        let uri = `${webroot}${url}`;
        return doPost(uri, searchParams, "application/x-www-form-urlencoded");
    }

    getPrice(data) {
        const url = `api/prj/product/conf/price.${languagepath}.json`

        return this.get(url, data)
    }

    /**
     *
     * @param params A Valid object for the init of URLSearchParams
     * @param quantity quantity to be put in basket, default: 1
     * @returns {Promise<T | void>}
     */
    addToBasket ( params, quantity = 1 ) {

        const searchParams = new URLSearchParams( params )
        
        const url = `${webroot}myinterfaces/${languagepath}/shop/session/basket/items/${this.key}/${quantity}?${searchParams.toString()}`
        
        return doPut(url).then(response => {
            $('body').trigger('basketChanged', response);

            searchParams.append( "productKey", this.key)
            Prj.TrackingEvent.addToCart(searchParams.toString());
        }).catch(xhr => console.log(xhr))
    }

    saveConfiguration ( name, params ) {

        const searchParams = new URLSearchParams( params )
        searchParams.append( "configurationName", name)

        const url = `${webroot}myinterfaces/${languagepath}/prj/saveconf/${this.key}.json?${searchParams.toString()}`

        return doPost(url)
            .catch(xhr => console.log('The request failed!'))
    }
}

export function doGet(url, xhrAsResponse = false) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        onload(xhr, resolve, reject, xhrAsResponse);
        xhr.open("GET", url);
        xhr.send();
    });
}

export function doPost(url, data, contentType = null, xhrAsResponse = false) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        onload(xhr, resolve, reject, xhrAsResponse);
        xhr.open("POST", url);
        if (contentType !== null)
            xhr.setRequestHeader("Content-Type", contentType);
        xhr.send(data);
    });
}

export function doPut(url, data) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        onload(xhr, resolve, reject, false);
        xhr.open("PUT", url);
        xhr.send(data);
    });
}

function onload ( xhr, resolve, reject, xhrAsResponse ) {
    xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
            if(xhrAsResponse)
                resolve(xhr);
            else
                try{
                    resolve(JSON.parse(xhr.response))
                } catch (e) {
                    reject(e)
                }
        } else {
            reject(xhr);
        }
    };
}

export function base64ToBlob ( base64, type ) {
    let bytes = atob(base64);
    let buffer = new ArrayBuffer(bytes.length);
    let arr = new Uint8Array(buffer);

    for (let i = 0; i < bytes.length; i++) {
        arr[i] = bytes.charCodeAt(i);
    }
    return new Blob([buffer], { type: type });
}